<template>
  <section class="hero argentina">
      <div class="hero__content container">
        <div class="hero__content--info">
          <h1 class="hero__title">
            DNA House at Devconnect, Buenos Aires 
          </h1>
          <h2 class="hero__date">
            November 18th, 2025
          </h2>
          <a href="http://lu.ma/dnafund" target="_blank">
            <button class="hero__btn">
              Register Now
            </button>
          </a>
          <div class="venue-logo">
            <a href="https://maps.app.goo.gl/xdYcFPtXEc36w8pVA" target="_blank">
              <img src="@/assets/general/hero/nido.png" class="logo" alt="El nido">
            </a>
          </div>
        </div>
      </div>
    </section>
  </template>
  
  <script>

  export default {
    name: 'Hero',
    data () {
      return {
      }
    },
  }
  </script>
  
  <style lang="scss" scoped>
  @import "@/styles/components/hero.scss";

  .hero.argentina {
    padding: 100px 0 20px;
    min-height: 550px;
    background-position: center;
    background-image: linear-gradient(to bottom, rgb(0 0 0 / 90%) 0%, rgb(0 0 0 /55%)), url('~@/assets/general/argentina.webp');
  }

  .hero.argentina {
    .venue-logo {
      img {
        width: auto;
      }
    }
  }
  </style>